import type { SingleShipmentResponse } from '../../../apis/shipment';

interface BookingIdentity {
  courierId: string;
  trackingNumber: string;
}

/** The shipment id when it already carries this booking's carrier and tracking number, else null (also when it cannot be read). */
export const findSavedBooking = async (
  shipmentId: string | null | undefined,
  { courierId, trackingNumber }: BookingIdentity,
  fetchShipment: (id: string) => Promise<SingleShipmentResponse>
): Promise<string | null> => {
  if (!shipmentId) return null;
  try {
    const saved = (await fetchShipment(shipmentId))?.data?.data?.data;
    return saved?.courier_tracking_id === trackingNumber &&
      saved?.courier?.id === courierId
      ? shipmentId
      : null;
  } catch {
    return null;
  }
};
